/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: ratings-service.ts
 *
 * Created by kyang on 1/13/2021.
 */

angular.module('prism-ui.components.branding').service('RatingsService', function (
    this: JS5Object,
    _: JS5Object,
    RatingsResourceFactory: JS5Object,
) {
    let ratingSystemsPromise: JS5Object = undefined;
    const mapRatingSystems = (ratingSystems: Array<JS5Object>) => {
        return _.keyBy(ratingSystems, 'systemCode');
    };

    this.getRatingSystems = () => {
        if (_.isUndefined(ratingSystemsPromise)) {
            ratingSystemsPromise = RatingsResourceFactory.getRatingSystems().$promise.then(mapRatingSystems);
        }
        return ratingSystemsPromise;
    };

    this.getRatingSystemByRatingCode = (ratingSystems: JS5Object, ratingCodeNeedle: JS5Object) => {
        return _.find(
            ratingSystems,
            (ratingSystem: JS5Object) => _.some(
                ratingSystem.ratingCodes,
                (ratingCode: JS5Object) => ratingCode.id === ratingCodeNeedle.id
            )
        );
    };
});
